module.exports = __webpack_public_path__ + "assets/img/34_767.02634432.jpg";